import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { NavLink, Collapse } from "reactstrap";
import { BsChevronUp, BsChevronDown } from "react-icons/bs";
import TabFilterContext from "../../../contexts/tabFilter";
import "../styles/collapse-section.scss";

function CollapseSection(props) {
  const { children, sectionName, bodyClassName } = props;

  const { maxHeight, toggleSection, section } = useContext(TabFilterContext);
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    const status = !isOpen;
    toggleSection(status ? sectionName : "");
  };

  useEffect(() => {
    setIsOpen(sectionName === section);
  }, [section, sectionName]);

  return (
    <div>
      <NavLink
        onKeyDown={(e) => {
          if (e.type === "keydown" && e.keyCode === 13) {
            toggle();
          }
        }}
        tabIndex="0"
        onClick={() => toggle()}
        className="d-flex justify-content-between menu-filter filter-collapse-head"
      >
        <span>{sectionName}</span>
        {isOpen && <BsChevronUp />}
        {!isOpen && <BsChevronDown />}
      </NavLink>
      <Collapse
        isOpen={isOpen}
        className={bodyClassName}
        style={{ maxHeight: `calc(${window.innerHeight}px - ${maxHeight}px)` }}
      >
        <button
          type="button"
          className="collapse-section-wrapper"
          onClick={toggle}
        >
          {children}
        </button>
      </Collapse>
    </div>
  );
}

CollapseSection.defaultProps = {
  bodyClassName: ""
};

CollapseSection.propTypes = {
  children: PropTypes.node.isRequired,
  sectionName: PropTypes.string.isRequired,
  bodyClassName: PropTypes.string
};
export default CollapseSection;
